export const userRoles = {
  STANDARAD: 1,
  ADMIN: 2,
  MANAGER: 3,
  ENHANCED_MANAGER: 4,
  INCIDENT_ADVISOR_OR_LEADER: 5,
  LOCAL_INCIDENT_MANAGER: 6,
  SENIOR_INCIDENT_MANAGER: 7,
};
